import { useSelector } from 'react-redux';
import { currentCompanyDateFormatSelector } from 'domain/companies';

const DEFAULT_DATE_FORMAT = 'DD/MM/YYYY';

interface CompanyDateFormatResponse {
  dateFormat: string;
  dateFormatWithTime: string;
}

const useCompanyDateFormat = (): CompanyDateFormatResponse => {
  const companyDateFormat = useSelector(currentCompanyDateFormatSelector);
  const dateFormat = companyDateFormat || DEFAULT_DATE_FORMAT;

  return {
    dateFormat,
    dateFormatWithTime: `${dateFormat} HH:mm`,
  };
};

export default useCompanyDateFormat;
